import React from 'react';
import { Typography, Spin, Space } from 'antd';
import isEmpty from 'lodash/isEmpty';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Text } = Typography;

/**
 * StreamingMessage - AI response being streamed. Matches assistant style:
 * plain text without a bubble, no border.
 */
export default function StreamingMessage(props) {
  const { content } = props
  const contentArray = Array.isArray(content) ? content : [];

  if (isEmpty(contentArray)) return null;

  const isStatus = contentArray.some(chunk => chunk.type === 'status');

  const combinedText = contentArray
    .map(chunk => (typeof chunk === 'string' ? chunk : chunk.text || ''))
    .join('');

  if (!combinedText) return null;

  if (isStatus) {
    return (
      <div style={{ display: 'flex', marginBottom: '16px', padding: '2px 4px' }}>
        <Space size={8} align="center">
          <Spin size="small" />
          <Text type="secondary" style={{ fontSize: '13px', fontStyle: 'italic' }}>
            {combinedText}
          </Text>
        </Space>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', marginBottom: '20px', minWidth: 0, maxWidth: '100%' }}>
      <div style={{ maxWidth: '90%', minWidth: 0, padding: '2px 4px', overflow: 'hidden' }}>
        <div style={{ fontSize: '14px', margin: 0, minWidth: 0, maxWidth: '100%', color: '#1f2937' }}>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              p: ({ node, ...props }) => <p style={{ margin: 0, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'break-word', maxWidth: '100%' }} {...props} />,
              a: ({ node, ...props }) => <a style={{ color: '#1890ff', overflowWrap: 'anywhere', wordBreak: 'break-all' }} target="_blank" rel="noopener noreferrer" {...props} />,
              ul: ({ node, ...props }) => <ul style={{ paddingLeft: '20px', margin: '8px 0', maxWidth: '100%' }} {...props} />,
              ol: ({ node, ...props }) => <ol style={{ paddingLeft: '20px', margin: '8px 0', maxWidth: '100%' }} {...props} />,
              li: ({ node, ...props }) => <li style={{ marginBottom: '4px', overflowWrap: 'anywhere', wordBreak: 'break-word' }} {...props} />,
              table: ({ node, ...props }) => (
                <div style={{ overflowX: 'auto', maxWidth: '100%', margin: '8px 0' }}>
                  <table style={{ borderCollapse: 'collapse', fontSize: '13px' }} {...props} />
                </div>
              ),
              code: ({ node, inline, className, children, ...props }) => {
                return !inline ? (
                  <pre style={{ background: '#f2f1ed', padding: '12px', borderRadius: '6px', overflowX: 'auto', margin: '8px 0', maxWidth: '100%', boxSizing: 'border-box' }}>
                    <code className={className} style={{ display: 'block', whiteSpace: 'pre', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: '12.5px' }} {...props}>
                      {children}
                    </code>
                  </pre>
                ) : (
                  <code style={{ background: '#f2f1ed', padding: '2px 4px', borderRadius: '4px', fontSize: '12px', overflowWrap: 'anywhere', wordBreak: 'break-all' }} {...props}>
                    {children}
                  </code>
                )
              }
            }}
          >
            {combinedText}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  )
}
